import Email from "../fundamentals/email/Email";
import Phone from "../fundamentals/phone/Phone";

class CustomerContact {
  constructor(
    private readonly _phone: Phone = new Phone(),
    private readonly _email: Email = new Email(),
  ) {
  }

  get phone() {
    return this._phone;
  }

  get email() {
    return this._email;
  }
}

export default CustomerContact;
